export default __webpack_public_path__ + "static/media/new-search-icon.ce61013e.svg";